import { baseStyles } from '../common/baseStyles';
export const resolveInputFontSize = (theme, size) => {
  switch (size) {
    case 'small':
    case 'sm':
      return theme.tokens.ComponentTextInputInputFontSizeSmall;
    case 'medium':
    case 'md':
      return theme.tokens.ComponentTextInputInputFontSizeMedium;
    case 'large':
    case 'lg':
      return theme.tokens.ComponentTextInputInputFontSizeLarge;
    default:
      return theme.tokens.ComponentTextInputInputFontSizeMedium;
  }
};
export const resolveBorder = (validationStateType, disabled, readOnly, theme, open) => {
  if (disabled) {
    return `1px solid ${theme.tokens.ComponentTextInputDisabledBorderColor}`;
  } else if (readOnly) {
    return `1px solid ${theme.tokens.ComponentTextInputReadOnlyBorderColor}`;
  } else if (validationStateType === 'error') {
    return `1px solid ${theme.tokens.ComponentTextInputErrorColor}`;
  } else if (open) {
    return `1px solid ${theme.tokens.ComponentTextInputBorderFocusColor}`;
  } else if (validationStateType === 'success') {
    return `1px solid ${theme.tokens.ComponentTextInputBorderSuccessColor}`;
  } else {
    return `1px solid ${theme.tokens.ComponentTextInputBorderColor}`;
  }
};
export const resolveInputSize = (theme, size) => {
  switch (size) {
    case 'small':
    case 'sm':
      return theme.tokens.ComponentTextInputInputSizeSmall;
    case 'medium':
    case 'md':
      return theme.tokens.ComponentTextInputInputSizeMedium;
    case 'large':
    case 'lg':
      return theme.tokens.ComponentTextInputInputSizeLarge;
    default:
      return theme.tokens.ComponentTextInputInputSizeMedium;
  }
};
export const resolveMultilineLineHeight = (theme, size) => {
  switch (size) {
    case 'small':
    case 'sm':
      return '130%';
    case 'large':
    case 'lg':
      return '125%';
    case 'medium':
    case 'md':
    default:
      return '125%';
  }
};
export const resolvePadding = size => {
  switch (size) {
    case 'small':
    case 'sm':
      return '0px 4px 0px 8px';
    case 'large':
    case 'lg':
      return '0px 10px 0px 16px';
    case 'medium':
    case 'md':
    default:
      return '0px 8px 0px 12px';
  }
};
export const resolveMultilinePadding = size => {
  switch (size) {
    case 'small':
    case 'sm':
      return '8px';
    case 'large':
    case 'lg':
      return '14px 16px 14px 16px';
    case 'medium':
    case 'md':
    default:
      return '12px';
  }
};
export const textInputStyleBuilder = (theme, validationStateType, readOnly, disabled, multiline, size, textAlign) => ({
  '.MuiOutlinedInput-notchedOutline': {
    outline: 'none',
    border: readOnly ? 'hidden !important' : resolveBorder(validationStateType, disabled, readOnly, theme, false)
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      outline: 'none',
      border: `1px solid ${theme.tokens.ComponentTextInputBorderFocusColor}`,
      boxShadow: theme.tokens.SemRingFocus
    }
  },
  '&.MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.tokens.ComponentTextInputDisabledColor,
    color: theme.tokens.ComponentTextInputDisabledColor,
    backgroundColor: theme.tokens.ComponentTextInputDisabledBgColor
  },
  '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
    border: resolveBorder(validationStateType, disabled, readOnly, theme, false) || `1px solid ${theme.tokens.ComponentTextInputBorderColor}`
  },
  '&.MuiOutlinedInput-root': {
    padding: multiline ? resolveMultilinePadding(size) : resolvePadding(size),
    height: multiline ? 'auto' : resolveInputSize(theme, size),
    gap: size === 'small' || size === 'sm' ? '6px' : '8px',
    backgroundColor: theme.tokens.ComponentTextInputBg,
    width: '100%'
  },
  '&.MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.tokens.ComponentTextInputDisabledBgColor
  },
  '& .MuiOutlinedInput-input': {
    textAlign,
    borderRadius: '0',
    position: 'relative',
    padding: '0',
    backgroundColor: disabled ? theme.tokens.ComponentTextInputDisabledBgColor : theme.tokens.ComponentTextInputBg,
    fontSize: resolveInputFontSize(theme, size),
    fontFamily: theme.tokens.ComponentTextInputFontFamily,
    fontWeight: theme.tokens.ComponentTextInputFontWeight,
    fontVariationSettings: "'opsz' 16",
    lineHeight: multiline ? resolveMultilineLineHeight(theme, size) : '100%',
    height: multiline ? 'auto' : 'fit-content',
    color: disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputInputColor,
    width: '100%',
    cursor: readOnly || disabled ? 'not-allowed' : undefined,
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    '&:focus': {
      background: 'transparent'
    }
  }
});
export const resolveLabelFontSize = (theme, size) => {
  switch (size) {
    case 'small':
    case 'sm':
      return theme.tokens.ComponentTextInputLabelFontSizeSmall;
    case 'medium':
    case 'md':
      return theme.tokens.ComponentTextInputLabelFontSizeMedium;
    case 'large':
    case 'lg':
      return theme.tokens.ComponentTextInputLabelFontSizeLarge;
    default:
      return theme.tokens.ComponentTextInputLabelFontSizeMedium;
  }
};
export const resolveMinWidth = size => {
  if (size === 'small' || size === 'sm') {
    return '136px';
  } else if (size === 'medium' || size === 'md') {
    return '160px';
  } else if (size === 'large' || size === 'lg') {
    return '200px';
  }
  return 'unset';
};
export const textInputContainerStyle = (layout, readOnly, size) => ({
  minWidth: resolveMinWidth(size),
  pointerEvents: readOnly ? 'none' : '',
  ...baseStyles
});
export const styledInputMessageContainer = {
  display: 'flex',
  flexFlow: 'column wrap',
  gap: '4px',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};